import { BindableComponent } from "components/components/Component";

export function fireDataChangedEvent(
    component: BindableComponent,
    view: Element,
    data: any,
    originalData?: any,
    isValid?: boolean)  {
    let event = new CustomEvent<DataChangedEventDetail>("dataChanged", {
        bubbles: true,
        detail: {
            originalData,
            data,
            isValid,
            component,
        },
    });
    view.dispatchEvent(event);
}
export function fireInitDataChangedEvent(
    component: BindableComponent,
    view: Element,
    data: any,
    originalData?: any,
    isValid?: boolean)  {
    let event = new CustomEvent<DataChangedEventDetail>("dataChanged", {
        bubbles: true,
        detail: {
            originalData,
            data,
            isValid,
            component,
            initializationChange: true,
        },
    });
    view.dispatchEvent(event);
}

export function fireDataChangedCleared(
    componentId: string,
    view: Element)  {
    let event = new CustomEvent("dataChangeCleared", {
        bubbles: true,
        detail: {
            componentId,
        },
    });
    view.dispatchEvent(event);
}

export interface DataChangedEventDetail {
    originalData: any;
    data: any;
    isValid: boolean;
    component: BindableComponent;
    initializationChange?: boolean;
}
